import type { ExtraReducerBuilder } from '@ui/features/quote-builder/types/shared';
import type { WritableQuoteBuilderStateType } from '@ui/features/quote-builder/types/state';

function closeIssuesDrawerWhenIssuesAreEmpty(
  state: WritableQuoteBuilderStateType,
) {
  if (Object.keys(state.issues).length === 0) {
    state.isIssueDrawerOpen = false;
  }
}

export function issuesDrawerReducer(builder: ExtraReducerBuilder) {
  builder.addMatcher(() => true, closeIssuesDrawerWhenIssuesAreEmpty);
}
